import { QueryExpressionParserType } from '../types';
import { parseOperatorChain, parsePrimary } from './helpers';

export const parseQueryExpression: QueryExpressionParserType = (
  tokens,
  startIndex
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
) => parseOperatorChain(tokens, startIndex, 'OR', parseAndChain);

const parseAndChain: QueryExpressionParserType = (tokens, index) =>
  parseOperatorChain(tokens, index, 'AND', (t, i) =>
    parsePrimary(t, i, parseQueryExpression)
  );
